module.exports = __webpack_public_path__ + "img/backyard-alt-wide.c4b812ec.jpg";